export const getRead = (id) => {
  try { return parseInt(localStorage.getItem(`cr_${id}`) || "0", 10); } catch { return 0; }
};
export const setRead = (id, n) => {
  try { localStorage.setItem(`cr_${id}`, String(n)); } catch { /* ignore */ }
};
export const hasUnread = (post) => (post?.comment_count || 0) > getRead(post?.id);
